import { useState } from 'react';
import api from '../services/api';

export const useApi = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const request = async (method, url, data = null, config = {}) => {
    setLoading(true);
    setError(null);
    
    try {
      const response = await api({ method, url, data, ...config });
      return { data: response.data, error: null };
    } catch (err) {
      setError(err.response?.data?.message || err.message);
      return { data: null, error: err.response?.data?.message || err.message };
    } finally {
      setLoading(false);
    }
  };

  const get = (url, config) => request('get', url, null, config);
  const post = (url, data, config) => request('post', url, data, config);
  const put = (url, data, config) => request('put', url, data, config);
  const del = (url, config) => request('delete', url, null, config);

  return { loading, error, get, post, put, del };
};